"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultFieldConfig = void 0;
// constants/defaultFieldConfig.ts
exports.defaultFieldConfig = {
    "Textarea": {
        type: "textarea",
        label: "Textarea",
        placeholder: "Enter text...",
    },
    "Text Field": {
        type: "text",
        label: "Text Field",
        placeholder: "Enter text...",
    },
    "Multiple choice": {
        type: "radio",
        label: "Multiple choice",
        options: [
            { value: "option_1", label: "Option 1" },
            { value: "option_2", label: "Option 2" },
            { value: "option_3", label: "Option 3" },
        ],
    },
    "Checkboxes": {
        type: "checkbox",
        label: "Checkboxes",
        options: [
            { value: "option_a", label: "Option A" },
            { value: "option_b", label: "Option B" },
            { value: "option_c", label: "Option C" },
        ],
    },
    "Drop-down": {
        type: "select",
        label: "Drop-down",
        options: [
            { value: "option_a", label: "Option A" },
            { value: "option_b", label: "Option B" },
            { value: "option_c", label: "Option C" },
        ],
    },
    "File upload": {
        type: "file",
        label: "File upload",
    },
    "Date": {
        type: "date",
        label: "Date",
    },
    "Time": {
        type: "time",
        label: "Time",
    },
    "Phone": {
        type: "tel",
        label: "Phone",
        placeholder: "Enter phone number",
    },
    "Email": {
        type: "email",
        label: "Email",
        placeholder: "Enter email",
    },
};
